import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { collections } from '../../data/collections';
import { images } from '../../data/images';
import { productsForCollection } from '../../utils/products';
import { Reveal } from '../ui/Reveal';
const layout: Record<string, {
  span: string;
  image: string;
  position?: string;
}> = {
  'voor-haar': {
    span: 'col-span-2 aspect-[4/3] lg:row-span-2 lg:aspect-auto',
    image: images.ritual,
    position: 'object-[50%_35%]'
  },
  'voor-hem': {
    span: 'col-span-1 aspect-[4/5] lg:aspect-auto',
    image: images.him,
    position: 'object-[50%_25%]'
  },
  nieuw: {
    span: 'col-span-1 aspect-[4/5] lg:aspect-auto',
    image: images.cactus
  },
  bestsellers: {
    span: 'col-span-1 aspect-[4/5] lg:aspect-auto',
    image: images.argan
  },
  cadeaus: {
    span: 'col-span-1 aspect-[4/5] lg:aspect-auto',
    image: images.giftset
  }
};
export function ShopTiles() {
  const tiles = collections.filter(c => layout[c.slug]);
  return <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-28" data-id="element-119" data-mp="e4amr55l1fmo">
      <Reveal className="mb-10 flex items-end justify-between gap-6" data-id="element-120" data-mp="e26nj0imp4sq">
        <h2 className="max-w-xl text-4xl font-semibold tracking-display text-ink sm:text-5xl" data-id="element-121" data-mp="a40l24otpbdm">Waar ben je naar op zoek?</h2>
        <Link to="/collectie/alles" className="hidden whitespace-nowrap text-sm font-medium underline underline-offset-4 sm:block" data-id="element-122" data-mp="51rrb644m5ag">
          Alle producten
        </Link>
      </Reveal>

      <ul className="grid grid-cols-2 gap-3 lg:h-[720px] lg:grid-cols-4 lg:grid-rows-2 lg:gap-4" data-id="element-123" data-mp="3rcdr8uhgxh3d">
        {tiles.map(c => {
        const t = layout[c.slug];
        return <li key={c.slug} className={t.span} data-id="element-124" data-mp="3ijahox9y1oe0">
              <Link to={`/collectie/${c.slug}`} className="group relative block h-full overflow-hidden rounded-3xl bg-surface" data-id="element-125" data-mp="3djeev1czg301">
                <img src={t.image} alt="" className={`absolute inset-0 h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.04] ${t.position ?? ''}`} data-id="element-126" data-mp="38kky902efvvn" />
                <span className="absolute inset-x-3 bottom-3 flex items-center justify-between gap-3 rounded-2xl bg-white/95 px-4 py-3 backdrop-blur lg:inset-x-4 lg:bottom-4" data-id="element-127" data-mp="2tzyzodau8w8r">
                  <span data-id="element-128" data-mp="2kyr442zpi9id">
                    <span className="block text-base font-semibold tracking-tight text-ink lg:text-lg" data-id="element-129" data-mp="2kzaixau28hs6">{c.title}</span>
                    <span className="block text-xs text-muted" data-id="element-130" data-mp="3codnkrpuzu5c">{productsForCollection(c).length} producten</span>
                  </span>
                  <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-ink text-white transition-colors duration-150 group-hover:bg-clay" data-id="element-131" data-mp="3hlvt084o3r8l">
                    <ArrowUpRightIcon className="h-4 w-4" data-id="element-132" data-mp="37x5ejwsfyasp" />
                  </span>
                </span>
              </Link>
            </li>;
      })}
      </ul>
    </section>;
}